export default __webpack_public_path__ + "static/media/slide1.11f4e4e4.jpg";